import type { ReactElement, ReactNode } from 'react';
import { cloneElement, isValidElement } from 'react';

import type { TPagination } from '../models';

type TUsePaginationProps = {
    dataLength: number;
    nextPage: ReactNode;
    pagination?: TPagination;
};

export const usePagination = ({ dataLength, nextPage, pagination }: TUsePaginationProps) => {
    const { itemsPerPage, nextPageHandler, page } = pagination || {};
    const hasPagination = itemsPerPage && page;

    const toSlice = hasPagination ? page * itemsPerPage : undefined;
    const restCount = toSlice ? dataLength - toSlice : 0;

    const NextPageSlot =
        nextPage && hasPagination && restCount > 0
            ? isValidElement(nextPage)
                ? cloneElement(nextPage as ReactElement, {
                      onClick: nextPageHandler,
                      restCount,
                  })
                : nextPage
            : null;

    return { NextPageSlot, toSlice };
};
